export default __webpack_public_path__ + "static/media/player_-1.1335ad1c.png";